import { useEffect } from 'react';
import logger from '../utils/logger.js';
import '../utils/logToSlack.js';

// Install and initialize Google Tag Manager and Gtag (GA4) scripts
const useCustomGTMScripts = (googleTagManagerId) => {
    useEffect(() => {
        const gtmScript = document.createElement('script');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        // 'disableAnalytics' cookie is used to disable Analytics for automation tests.
        const disableAnalytics = document.cookie
            .split('; ')
            .find(row => row.startsWith('disableAnalytics'));
        if (googleTagManagerId && !disableAnalytics) {
            // Google Tag Manager
            gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${googleTagManagerId}`;
            gtmScript.async = true;
            document.body.appendChild(gtmScript);
            logger('GTM script loaded', { category: 'analytics' });
        }
    }, []);
};

export { useCustomGTMScripts as default };
//# sourceMappingURL=useCustomGTMScripts.js.map
